import React from 'react';
import { JobStatusResponse } from '../types';

interface JobStatusProps {
  jobStatus: JobStatusResponse;
  onDownload: () => void;
  onNewConversion: () => void;
  isDownloading: boolean;
}

const JobStatus: React.FC<JobStatusProps> = ({
  jobStatus,
  onDownload,
  onNewConversion,
  isDownloading,
}) => {
  const getStatusIcon = () => {
    switch (jobStatus.status) {
      case 'PENDING':
        return '⏳';
      case 'PROCESSING':
        return '⚙️';
      case 'COMPLETED':
        return '✅';
      case 'ERROR':
        return '❌';
      default:
        return '❓';
    }
  };

  const getStatusText = () => {
    switch (jobStatus.status) {
      case 'PENDING':
        return 'Aguardando processamento';
      case 'PROCESSING':
        return 'Processando currículo';
      case 'COMPLETED':
        return 'Conversão concluída';
      case 'ERROR':
        return 'Erro no processamento';
      default:
        return 'Status desconhecido';
    }
  };

  const getStatusDescription = () => {
    switch (jobStatus.status) {
      case 'PENDING':
        return 'Seu currículo está na fila de processamento';
      case 'PROCESSING':
        return 'Estamos convertendo seu currículo para o padrão Innvo';
      case 'COMPLETED':
        return 'Seu currículo foi convertido com sucesso';
      case 'ERROR':
        return 'Ocorreu um erro durante o processamento';
      default:
        return '';
    }
  };

  return (
    <div className="status-container">
      <div className="status-header">
        <div className={`status-icon ${jobStatus.status.toLowerCase()}`}>
          {getStatusIcon()}
        </div>
        <div className="status-info">
          <h3>{getStatusText()}</h3>
          <p>{getStatusDescription()}</p>
        </div>
      </div>

      {jobStatus.status === 'PROCESSING' && jobStatus.progress !== undefined && (
        <div className="progress-bar-container">
          <div className="progress-bar">
            <div
              className="progress-bar-fill"
              style={{ width: `${jobStatus.progress}%` }}
            />
          </div>
          <p className="progress-text">{jobStatus.progress}% concluído</p>
        </div>
      )}

      {jobStatus.status === 'ERROR' && jobStatus.errorMessage && (
        <div className="error-details">
          <h4>Detalhes do erro:</h4>
          <p>{jobStatus.errorMessage}</p>
        </div>
      )}

      {jobStatus.status === 'COMPLETED' && jobStatus.outputDownloadUrl && (
        <>
          <button
            className="download-button"
            onClick={onDownload}
            disabled={isDownloading}
          >
            {isDownloading ? 'Baixando...' : 'Baixar PDF Convertido'}
          </button>
          <button className="new-conversion-button" onClick={onNewConversion}>
            Converter Outro Currículo
          </button>
        </>
      )}

      {jobStatus.status === 'ERROR' && (
        <button className="new-conversion-button" onClick={onNewConversion}>
          Tentar Novamente
        </button>
      )}

      <div style={{ marginTop: '20px', fontSize: '0.875rem', color: '#666' }}>
        <p>
          <strong>ID do Job:</strong> {jobStatus.jobId}
        </p>
        <p>
          <strong>Criado em:</strong>{' '}
          {new Date(jobStatus.createdAt).toLocaleString('pt-BR')}
        </p>
        {jobStatus.updatedAt && (
          <p>
            <strong>Atualizado em:</strong>{' '}
            {new Date(jobStatus.updatedAt).toLocaleString('pt-BR')}
          </p>
        )}
      </div>
    </div>
  );
};

export default JobStatus;
